import { useEffect, useState } from 'react';
import { type BruteForceProtectionStatus, getUserIP } from '../utils/bruteForceProtection';

export const useBruteForceProtection = () => {
  const [bruteForceStatus, setBruteForceStatus] = useState<BruteForceProtectionStatus | null>(null);
  const [isLoginBlocked, setIsLoginBlocked] = useState<boolean>(false);
  const [loginDelay, setLoginDelay] = useState<number>(0);
  const [userIP, setUserIP] = useState<string | null>(null);
  const [delayMessage, setDelayMessage] = useState<string | null>(null);
  const [delayTimeoutId, setDelayTimeoutId] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const initializeUserIP = async (): Promise<void> => {
      try {
        const ip = await getUserIP();
        setUserIP(ip);
      } catch (_error) {
        // Failed to get user IP
      }
    };
    initializeUserIP();
  }, []);

  return {
    bruteForceStatus,
    setBruteForceStatus,
    isLoginBlocked,
    setIsLoginBlocked,
    loginDelay,
    setLoginDelay,
    userIP,
    delayMessage,
    setDelayMessage,
    delayTimeoutId,
    setDelayTimeoutId,
  };
};
